/**
 * Step indicator + code entry + verify CTA (sheet body).
 * @see ../atomicRules.ts
 */
import { StyleSheet } from 'react-native';
import { appTheme } from '../../appTheme';
import type { ThemeColors } from '../../store';

export function createOtpCodeEntrySheetStyles(c: ThemeColors) {
  return StyleSheet.create({
    /** Intrinsic — % / flex:1 heights collapse inside center shrink-wrap panels. */
    keyboardView: { width: '100%', flexGrow: 0, flexShrink: 1 },
    scroll: { width: '100%', flexGrow: 0, flexShrink: 1 },
    scrollContent: {
      flexGrow: 0,
      paddingHorizontal: appTheme.spacing.lg,
      paddingTop: appTheme.spacing.sm,
      alignItems: 'center',
      maxWidth: 440,
      width: '100%',
      alignSelf: 'center',
    },
    stepsContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: appTheme.spacing.xl,
    },
    stepCircle: {
      width: 32,
      height: 32,
      borderRadius: 16,
      backgroundColor: c.border,
      justifyContent: 'center',
      alignItems: 'center',
    },
    stepCircleActive: {
      backgroundColor: c.primary,
    },
    stepText: {
      fontSize: 14,
      fontWeight: '600',
      color: c.textSecondary,
    },
    stepTextActive: {
      color: c.onPrimary,
    },
    stepLine: {
      width: 40,
      height: 2,
      backgroundColor: c.border,
      marginHorizontal: appTheme.spacing.sm,
    },
    title: {
      fontSize: 24,
      fontWeight: '700',
      color: c.text,
      marginBottom: appTheme.spacing.md,
    },
    statusContainer: {
      marginVertical: appTheme.spacing.lg,
    },
    subtitle: {
      fontSize: 14,
      color: c.textSecondary,
      textAlign: 'center',
      marginBottom: appTheme.spacing.xl,
      lineHeight: 22,
    },
    phoneText: {
      fontWeight: '600',
      color: c.text,
    },
    resendContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: appTheme.spacing.xl,
    },
    resendText: {
      fontSize: 14,
      color: c.textSecondary,
    },
    resendLink: {
      fontSize: 14,
      fontWeight: '600',
      color: c.primary,
    },
    timerContainer: {
      marginBottom: appTheme.spacing.xl,
    },
    timerText: {
      fontSize: 14,
      color: c.textSecondary,
    },
    timerValue: {
      fontWeight: '600',
      color: c.primary,
    },
  });
}

export type OtpCodeEntrySheetStyles = ReturnType<typeof createOtpCodeEntrySheetStyles>;
